import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TopPinsGrid = ({ pins }) => {
  const [hoveredPin, setHoveredPin] = useState(null);

  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Top Performing Pins</h3>
        <button className="text-sm text-primary hover:underline font-medium">
          View All
        </button>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {pins?.map((pin) => (
          <div
            key={pin?.id}
            className="relative group cursor-pointer"
            onMouseEnter={() => setHoveredPin(pin?.id)}
            onMouseLeave={() => setHoveredPin(null)}
          >
            <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-muted">
              <Image
                src={pin?.image}
                alt={pin?.imageAlt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              
              {hoveredPin === pin?.id && (
                <div className="absolute inset-0 bg-black/60 flex flex-col justify-end p-4 transition-opacity duration-300">
                  <h4 className="text-white font-semibold text-sm mb-2 line-clamp-2">
                    {pin?.title}
                  </h4>
                  <div className="flex items-center gap-4 text-white text-xs">
                    <div className="flex items-center gap-1">
                      <Icon name="Eye" size={14} />
                      <span>{pin?.impressions}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Bookmark" size={14} />
                      <span>{pin?.saves}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="MousePointerClick" size={14} />
                      <span>{pin?.clicks}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="mt-2">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-muted-foreground">
                  Engagement Rate
                </span>
                <span className="text-xs font-bold text-success">
                  {pin?.engagementRate}
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-1.5 mt-1">
                <div
                  className="bg-success h-1.5 rounded-full transition-all duration-300"
                  style={{ width: pin?.engagementRate }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopPinsGrid;